export enum ContactType {
    SPEAKER,
    EXHIBITOR,
    VISITOR
}
